import { inject } from "@angular/core";
import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from "@angular/forms";
import { LoggerService } from "../shared/logger.service";
import { PlacementReviewStudentType } from "../models/models.lib";
import { FormModes } from "../common/constants.lib";
import { isNotNull } from "../common/utils.lib";


export const confirmedPasswordValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  // console.log(`confirmedPasswordValidator: `, control);
  const password = control.get('password');
  const confirmedPassword = control.get('confirmedPassword');
  // console.log(`confirmedPasswordValidator: `, {
  //   password: password?.value, confirmedPassword: confirmedPassword?.value
  // });
  const returning = password && confirmedPassword && password.value !== confirmedPassword.value ?
    { confirmedPasswordValidator: true } : null;
  // console.log(`confirmedPasswordValidator: `, {
  //   password: password ? password.value : null,
  //   confirmedPassword: confirmedPassword ? confirmedPassword.value : null,
  //   returning
  // });
  // console.log(`confirmedPasswordValidator: returning`, returning);
  return returning;
};

export const firstOrLastNameRequiredValidator: ValidatorFn =
  (group: AbstractControl): ValidationErrors | null => {

    const firstName = group.get('first_name')?.value?.trim();
    const lastName = group.get('last_name')?.value?.trim();

    return firstName || lastName
      ? null
      : { firstOrLastNameRequired: true };
  };

export const firstOrLastName2RequiredValidator: ValidatorFn =
  (group: AbstractControl): ValidationErrors | null => {

    const firstName = group.get('firstName')?.value?.trim();
    const lastName = group.get('lastName')?.value?.trim();

    // console.log(`firstOrLastName2RequiredValidator`, { firstName, lastName });

    return firstName || lastName
      ? null
      : { firstOrLastNameRequired: true };
  };

export function firstOrLastName3RequiredValidator(fieldName1: string, fieldName2: string): ValidatorFn {

  return (group: AbstractControl): ValidationErrors | null => {

    const firstName = group.get(fieldName1)?.value?.trim();
    const lastName = group.get(fieldName2)?.value?.trim();
    // console.log(`firstOrLastName3RequiredValidator`, { firstName, lastName });

    return firstName || lastName
      ? null
      : { firstOrLastNameRequired: true };
  };
}

export function compareFieldsRequiredValidator(controlName: string, matchingControlName: string): ValidatorFn {

  return (formGroup: AbstractControl): ValidationErrors | null => {
    const group = formGroup as FormGroup;
    const control = group.get(controlName);
    const matchingControl = group.get(matchingControlName);
    // console.log(`compareFieldsRequiredValidator`, { controlName, matchingControlName });

    // Safety check if controls are missing
    if (!control || !matchingControl) {
      return null;
    }

    // // Skip validation if the target control already has another error (e.g., required)
    // if (matchingControl.errors && !matchingControl.errors['firstOrLastNameRequired']) {
    //   return null;
    // }


    const firstName = control.value?.trim();
    const lastName = matchingControl?.value?.trim();
    // console.log(`compareFieldsRequiredValidator`, { firstName, lastName });

    if (!firstName && !lastName) {
      // console.log(`compareFieldsRequiredValidator:set error:`, { firstName: !firstName, lastName: !lastName });
      matchingControl.setErrors({
        firstOrLastNameRequired: true
      });
    } else {
      if (matchingControl.hasError('firstOrLastNameRequired')) {
        const errors = { ...matchingControl.errors };
        delete errors['firstOrLastNameRequired'];
        matchingControl.setErrors(Object.keys(errors).length ? errors : null);
      }
    }
    return null;
  };
}

export function compareNoMatchValidator(controlName: string, matchingControlName: string): ValidatorFn {

  return (formGroup: AbstractControl): ValidationErrors | null => {
    const group = formGroup as FormGroup;
    const control = group.get(controlName);
    const matchingControl = group.get(matchingControlName);
    // console.log(`compareNoMatchValidator`, { controlName, matchingControlName });

    // Safety check if controls are missing
    if (!control || !matchingControl) {
      return null;
    }

    const firstValue = control.value?.trim();
    const lastValue = matchingControl?.value?.trim();
    // console.log(`compareNoMatchValidator`, { firstValue, lastValue });

    if (!!firstValue && !!lastValue && firstValue === lastValue) {
      // console.log(`compareNoMatchValidator:set error:`, { firstName: !firstName, lastName: !lastName });
      matchingControl.setErrors({
        compareNotMatch: true
      });
    } else {
      if (matchingControl.hasError('compareNotMatch')) {
        const errors = { ...matchingControl.errors };
        delete errors['compareNotMatch'];
        matchingControl.setErrors(Object.keys(errors).length ? errors : null);
      }
    }
    return null;
  };
}

export function duplicateReviewStudentValidator(
  list: PlacementReviewStudentType[],
  mode: FormModes
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    // console.log(`duplicateReviewStudentValidator: `, list);
    if (!list?.length) {
      return null;
    }

    const value = control.value;
    if (!value) {
      return null;
    }

    const duplicate = list.find((o) =>
      o.student_email === value.student_email && o.placement_review_id === value.placement_review_id &&
      (mode === FormModes.NEW || o.id !== value.id)
    );
    // console.log(`duplicateReviewStudentValidator: `, duplicate);
    return duplicate ? { duplicateReviewStudent: true } : null;
  };
}


export const invalidPhoneValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {

  let returning = control.value && (!/^0[1-9]\d{8}$/.test(control.value)) && (!/^61[1-9]\d{8}$/.test(control.value))
    && (!/^\+61[1-9]\d{8}$/.test(control.value)) && (!/^\(0[1-9]\)\d{8}$/.test(control.value)) ?
    { invalidPhoneValidator: true } : null;
  // console.log(`invalidPhoneValidator: `, {
  //   value: control ? control.value : null,
  //   returning
  // });
  return returning;
};

export const invalidMobileValidator = (control: AbstractControl, isRequired: boolean): ValidationErrors | null => {
  // console.log('invalidMobileValidator:isRequired: ', isRequired);
  let returning = isRequired && control.value && (!/^04\d{8}$/.test(control.value)) && (!/^614\d{8}$/.test(control.value)) && (!/^\+614\d{8}$/.test(control.value)) ?
    { invalidMobileValidator: true } : null;
  // console.log(`invalidMobileValidator: `, {
  //   value: control ? control.value : null,
  //   isRequired,
  //   returning
  // });
  return returning;
};

export function specificNumbersValidator(specifiedNumbers: number[]): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value as number;

    if (!specifiedNumbers.includes(value)) {
      return { 'specificNumbers': true }; // Validation failed; value is not in specified numbers
    } else {
      return null; // Validation passed; the value is unique.
    }
  };
}
